import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import plPL from 'antd/locale/pl_PL';
import Layout from './components/Layout';
import RequireAuth from './components/RequireAuth';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import Login from './pages/Login';
import ProductList from './pages/ProductList';
import ProductEdit from './pages/ProductEdit';
import ProductDetail from './pages/ProductDetail';
import ProductGroupList from './pages/ProductGroupList';
import ProductGroupEdit from './pages/ProductGroupEdit';
import ProductGroupDetail from './pages/ProductGroupDetail';
import SpecManagement from './pages/SpecManagement';
import HomepageConfig from './pages/HomepageConfig';
import './App.css';

const AppRoutes: React.FC = () => {
  const { language } = useLanguage();

  return (
    <ConfigProvider locale={language === 'pl' ? plPL : zhCN}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <RequireAuth>
                <Layout>
                  <Routes>
                    <Route path="/" element={<ProductList />} />
                    <Route path="/products" element={<ProductList />} />
                    <Route path="/products/edit/:id?" element={<ProductEdit />} />
                    <Route path="/products/detail/:id" element={<ProductDetail />} />
                    <Route path="/product-group" element={<ProductGroupList />} />
                    <Route path="/product-group/add" element={<ProductGroupEdit />} />
                    <Route path="/product-group/edit/:id" element={<ProductGroupEdit />} />
                    <Route path="/product-group/detail/:id" element={<ProductGroupDetail />} />
                    <Route path="/specs" element={<SpecManagement />} />
                    <Route path="/homepage-config" element={<HomepageConfig />} />
                  </Routes>
                </Layout>
              </RequireAuth>
            }
          />
        </Routes>
      </Router>
    </ConfigProvider>
  );
};

const App: React.FC = () => (
  <LanguageProvider>
    <AppRoutes />
  </LanguageProvider>
);

export default App;
